import { Card } from "./Card";
import { ensureElement } from "../../../utils/utils";
import { categoryMap } from "../../../utils/constants";
export class CardPreview extends Card {
    constructor(container, actions) {
        super(container, {});
        this.inBasket = false;
        this._image = ensureElement('.card__image', this.container);
        this._category = ensureElement('.card__category', this.container);
        this._description = ensureElement('.card__text', this.container);
        this._button = ensureElement('.card__button', this.container);
        if (actions === null || actions === void 0 ? void 0 : actions.onButtonClick) {
            this._button.addEventListener('click', (e) => {
                var _a;
                e.stopPropagation();
                (_a = actions.onButtonClick) === null || _a === void 0 ? void 0 : _a.call(actions, this.id);
            });
        }
    }
    set image(value) {
        this.setImage(this._image, value, this.title);
    }
    set description(value) {
        this.setText(this._description, value);
    }
    set category(value) {
        this.setText(this._category, value);
        for (const key in categoryMap) {
            this._category.classList.toggle(categoryMap[key], key === value);
        }
    }
    set price(value) {
        super.price = value;
        this.setDisabled(this._button, value === null);
    }
    updateButtonText() {
        this._button.textContent = this.inBasket ? 'Удалить из корзины' : 'Купить';
    }
}
